import * as React from "react";
import { useTranslation } from "react-i18next";
import { Label } from "components/bootstrap";
export const STATUS_LABEL = {
  "all good": "status_badge.all_good",
  "heads up": "status_badge.heads_up"
};
const STATUS_STYLE = {
  "all good": "success",
  "heads up": "warning"
};
const StatusBadge = ({ status }) => {
  const { t } = useTranslation("enterprise_ai");
  return /* @__PURE__ */ React.createElement(Label, { bsStyle: STATUS_STYLE[status], uppercase: true }, t(STATUS_LABEL[status]));
};
export default StatusBadge;
